import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/authorization/login/login.component';
import { ApplicationPaths } from './constants/authorization/api-authorization.constants';
import { DashboardRoutingModule } from './components/dashboard/dashboard-routing.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthorizeGuard } from './guards/authorize/authorize.guard';



const routes: Routes = [
  { path: '', redirectTo: ApplicationPaths.Login, pathMatch: 'full' },
  { path: ApplicationPaths.Login, component: LoginComponent },
  { path: ApplicationPaths.LogOut, component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate:[AuthorizeGuard] },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    DashboardRoutingModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
